import React, { useContext } from "react";
import { FormInput } from "best-common-react";
import { EditCustomCardContext } from "../contexts/EditCustomCardContext";

const CardInfoTextInputs = () => {
  const editCustomCardContext = useContext(EditCustomCardContext);
  const { dispatch } = editCustomCardContext;
  const { dugoutCardInfo } = editCustomCardContext.state;

  return (
    <div>
      <div className="d-flex">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FormInput
            name="title-text-input"
            type="text"
            isRequired={false}
            isDisabled={false}
            label="Title"
            editable={true}
            value={dugoutCardInfo.title}
            onChangeFn={value => {
              dispatch({
                type: "setDugoutTitle",
                title: value
              });
            }}
          />
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FormInput
            name="venue-text-input"
            type="text"
            isRequired={false}
            isDisabled={false}
            label="Venue"
            editable={true}
            value={dugoutCardInfo.venue}
            onChangeFn={value => {
              dispatch({
                type: "setDugoutVenue",
                venue: value
              });
            }}
          />
        </div>
      </div>
      <div className="d-flex">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FormInput
            name="city-text-input"
            type="text"
            isRequired={false}
            isDisabled={false}
            label="City"
            editable={true}
            value={dugoutCardInfo.city}
            onChangeFn={value => {
              dispatch({
                type: "setDugoutCity",
                city: value
              });
            }}
          />
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FormInput
            name="state-text-input"
            type="text"
            isRequired={false}
            isDisabled={false}
            label="State/Province"
            editable={true}
            value={dugoutCardInfo.state}
            onChangeFn={value => {
              dispatch({
                type: "setDugoutState",
                state: value
              });
            }}
          />
        </div>
      </div>
      <div className="d-flex">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FormInput
            name="home-team-text-input"
            type="text"
            isRequired={false}
            isDisabled={false}
            label="Home Team"
            editable={true}
            value={dugoutCardInfo.homeTeamName}
            onChangeFn={value => {
              dispatch({
                type: "setDugoutHomeTeam",
                homeTeam: value
              });
            }}
          />
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FormInput
            name="away-team-text-input"
            type="text"
            isRequired={false}
            isDisabled={false}
            label="Away Team"
            editable={true}
            value={dugoutCardInfo.awayTeamName}
            onChangeFn={value => {
              dispatch({
                type: "setDugoutAwayTeam",
                awayTeam: value
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CardInfoTextInputs;
